<template>
  <v-btn icon @click="back" flat density="comfortable" color="transparent">
    <v-icon color="primary">mdi-chevron-left</v-icon>
  </v-btn>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter()

function back() {
  router.back()
}
</script>
